import React, { useEffect } from 'react';
import { Form, FormGroup, ListGroup, Label, ListGroupItem } from 'reactstrap';

import Body from '../Components/layout/Body';

const LOGIN_HELP = `
<div>
  <p>Eventually, Access Navigator will have a typical login process. You'll be able to login as a provider, then add a new client, or open up clients you've already worked with. Your data within Access Navigator will be available in the cloud as well as offline when needed.</p>
  <p>For now, though, we just have a very basic way to store data for a particular client, one client at a time.</p>
  <p>The client's data will be stored under the username you specify here.  This name needs to be unique (eventually, the software will take care of these things, but right now it doesn't).</p>
  <p>If you are participating in our user study, we'll give you a username to enter.  That way if for some reason you or we need to access the data in the future, we'll have a way to do it.</p>
  <p>If you just want to try out Access Navigator, or use it without worrying about storing data for the future, just leave the username blank. That will keep the data out of the database. The data will still be available in this browser unless / until you refresh the page.</p>
  <p class="aa-more-info"><strong>Tech note:</strong> How can I just "start over" when I'm trying things out? First, enter a blank username so that data aren't stored in the database. Then refresh your browser - this will reinitialize any previous data that's currently in the app.</p>  
</div>
`;

//content sub-component with unique content for this page
function UsersReviewContent(props) {
  const {
    provider,
    client,
  } = props;

  console.log('provider:', provider);
  console.log('client:', client);
  return(
    <>
    <Form>
      <FormGroup>
        <Label className="aa-bold-text">
          Practitioner
        </Label>
        <ListGroup>
          {provider ? Object.entries(provider).map(([key, value]) => {
            return (
              <ListGroupItem>
                {key} : {Array.isArray(value) ? `[${value.join(', ')}]` : (value ?? '---')}
              </ListGroupItem>
            );
          }) : <ListGroupItem disabled={true}>no provider is set</ListGroupItem>}
        </ListGroup>
        <Label className="aa-bold-text">
          Client
        </Label>
        <ListGroup>
        {client ? Object.entries(client).map(([key, value]) => {
            return (
              <ListGroupItem>
                {key} : {Array.isArray(value) ? `[${value.join(', ')}]` : (value ?? '---')}
              </ListGroupItem>
            );
          }) : <ListGroupItem disabled={true}>no client is set</ListGroupItem>}
        </ListGroup>
      </FormGroup>
    </Form>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function UsersReview(props) {
  const {
    provider,
    client,
    onContinue
  } = props;

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used, but could supply an image on page
    faIcon: "fa-users aa-fa-3x", //include this font-awesome icon in the image column of the page
    title: "Review provider and client info",
    subTitle: "DEV PURPOSES ONLY. This allows you to see the provider, client, and the client's most recent session data.",
    learnMore: {linkText: "Learn More about this temporary mock login process",
                title: "Our temporary mock login process",
                content: LOGIN_HELP
                },
    nextRoute: '', 
    sidebar: false
  }

  console.log("rendering UsersReview");

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <UsersReviewContent 
          provider={provider}
          client={client}
        />
      } 
      onContinue={onContinue}
    />
    </>
  );
}

export default UsersReview;